<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-md-6">
        <el-form-item label="Категория" prop="category_id">
          <el-select
            v-model="form.category_id"
            placeholder="Выберите категорию"
            style="width: 100%"
            value-key="id"
            @change="onCategoryChange"
          >
            <el-option-group
              v-for="group in categories"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="category in group.children"
                :key="category.id"
                :label="category.name"
                :value="category.id"
              />
            </el-option-group>
          </el-select>
          {{ $_ErrorMixin_getError('category_id') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Город" prop="city_id">
          <el-select
            v-if="cityOptions"
            v-model="form.city_id"
            filterable
            placeholder="Выберите город"
            remote
            :remote-method="getCity"
            reserve-keyword
            style="width: 100%"
          >
            <el-option
              v-for="city in cityOptions"
              :key="city.id"
              :label="city.name"
              :value="city.id"
            />
          </el-select>
          {{ $_ErrorMixin_getError('city_id') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Title (UA)" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Title (RU)" prop="title_ru">
          <el-input v-model="form.title_ru" />
          {{ $_ErrorMixin_getError('title_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Description (UA)" prop="description">
          <el-input
            v-model="form.description"
            :rows="4"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('description') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Description (RU)" prop="description_ru">
          <el-input
            v-model="form.description_ru"
            :rows="4"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('description_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Заголовок H1 (UA)" prop="h1">
          <el-input v-model="form.h1" />
          {{ $_ErrorMixin_getError('h1') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Заголовок H1 (RU)" prop="h1_ru">
          <el-input v-model="form.h1_ru" />
          {{ $_ErrorMixin_getError('h1_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="SEO текст (UA)" prop="seo_text">
          <el-input
            v-model="form.seo_text"
            :rows="6"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('seo_text') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="SEO текст (RU)" prop="seo_text_ru">
          <el-input
            v-model="form.seo_text_ru"
            :rows="6"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('seo_text_ru') }}
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ErrorMixin from '@/utils/ErrorMixin'

const defaultValues = {
  category_id: '',
  city_id: '',
  title: '',
  title_ru: '',
  description: '',
  description_ru: '',
  h1: '',
  h1_ru: '',
  seo_text: '',
  seo_text_ru: '',
}

export default {
  name: 'SeoTemplateForm',
  components: {},
  mixins: [ErrorMixin],
  data() {
    return {
      form: { ...defaultValues },
      rules: {
        category_id: [
          { required: true, message: 'Пожалуйста, выберите категорию', trigger: 'change' },
        ],
        city_id: [
          { required: true, message: 'Пожалуйста, выберите город', trigger: 'change' },
        ],
        title: [],
        title_ru: [],
        description: [],
        description_ru: [],
        h1: [],
        h1_ru: [],
        seo_text: [],
        seo_text_ru: [],
      },
      cityOptions: [],
    }
  },
  computed: {
    ...mapState('wishes/categories', [
      'categories',
    ]),
    isUpdate() {
      return this.$route.name === 'UpdateSeoTemplate'
    },
  },
  async created() {
    await Promise.all([
      this.getCities(),
      this.fetchCategories(),
      this.fetchSeoTemplate(),
    ])
  },
  methods: {
    ...mapActions('seoTemplates', [
      'createSeoTemplate',
      'updateSeoTemplate',
      'getSeoTemplateById',
    ]),
    ...mapActions('cities', [
      'fetchCities',
      'preloadCities',
    ]),
    ...mapActions('wishes/categories', ['fetchCategories']),
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isUpdate) {
              await this.updateSeoTemplate({formData: this.form, id: this.form.id})
              this.$message.success('SEO шаблон успешно обновлен')
            } else {
              await this.createSeoTemplate(this.form)
              this.$message.success('SEO шаблон успешно создан')
            }

            this.$_ErrorMixin_clearErrors()
            this.$router.push({ name: 'SeoTemplatesList' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    async fetchSeoTemplate() {
      const id = this.$route.params.id
      if (id) {
        const model = await this.getSeoTemplateById(id)
        this.fillForm(model)

        // Ensure selected city is in options
        if (model.city) {
          const cityExists = this.cityOptions.some((c) => c.id === model.city.id)
          if (!cityExists) {
            this.cityOptions.unshift(model.city)
          }
        }
      }
    },
    fillForm(model) {
      this.form = {
        ...this.form,
        ...model,
        category_id: model.category_id || model.category?.id || '',
        city_id: model.city_id || model.city?.id || '',
      }
    },
    async getCities() {
      this.cityOptions = await this.preloadCities()
    },
    async getCity(query) {
      if (query !== '') {
        this.cityOptions = await this.fetchCities({ search: query })
      }
    },
    onCategoryChange() {
      // Category change logic can be added here if needed
    },
  },
}
</script>

<style lang="sass" scoped>
.seo-templates-form__upload-image
  margin-bottom: 10px

.seo-templates-form__preview
  margin-top: 10px
  padding: 10px
  border: 1px solid #dcdfe6
  border-radius: 4px
  display: inline-block

.seo-templates-form__preview-image
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>
